import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';

const INPUT_TIMEOUT = 500;

const SearchBar = ({ onChange }) => {
    const [searchTerm, setSearchTerm] = useState();

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            onChange(searchTerm);
        }, INPUT_TIMEOUT);
        return () => clearTimeout(timeOutId);
    }, [searchTerm, onChange]);

    const handleChange = useCallback((event) => {
        setSearchTerm(event.target.value);
    }, [setSearchTerm]);

    return (
        <Grid container sx={{ width: '100%' }} justifyContent="flex-end" spacing={2}>
            <Grid>
                <TextField
                    placeholder="Search…"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    onChange={handleChange}
                />
            </Grid>
        </Grid>
    );
};

SearchBar.propTypes = {
    onChange: PropTypes.func.isRequired,
};

export default SearchBar;
